import { gql } from "@apollo/client";

export const ALL_EVALUACION_PROFESIONAL_REEMPLAZOS_GRILLA = gql`
  query evaluacionProfesionalReemplazoGrilla($idEvaluacion : Int!) {
    evaluacionProfesionalReemplazoGrilla(idEvaluacion : $idEvaluacion) {
      success
      error
      valorEsperado {
        idEvaluacionProfesional 
        idProfesional 
        idEvaluacion 
        idTipoProfesional 
        idFiguraProfesional 
        idHonorario 
        fechaDesde 
        fechaHasta 
        valor 
        virutal 
        extra 
        idTramo 
        viatico  
        fechaAlta 
        idUsuario 
        cambioSonda
        capacitacion
        emergencia
        extraduracion
        nombre
        apellido
        figuraProfesional
        idFrecuenciaPlan
        frecuenciaPlan
        idFrecuenciaRequerida
        frecuenciaRequerida
        puedeEditar
        idEvaluacionProfesionalOriginal
        apellidoOriginal
        nombreOriginal
        fechaDesdeOriginal
        fechaHastaOriginal
        idFrecuenciaRequeridaOriginal
        frecuenciaRequeridaOriginal
      }
    }
  }
`;
export const adaptEvaluacionProfesionalReemplazoGrilla = (evProfesional) => {
  return {
    idEvaluacionProfesional: evProfesional?.idEvaluacionProfesional,
    idProfesional: evProfesional?.idProfesional,
    idEvaluacion: evProfesional?.idEvaluacion,
    idTipoProfesional: evProfesional?.idTipoProfesional,
    idFiguraProfesional: evProfesional?.idFiguraProfesional,
    idHonorario: evProfesional?.idHonorario,
    fechaDesde: evProfesional?.fechaDesde,
    fechaHasta: evProfesional?.fechaHasta,
    valor: evProfesional?.valor,
    virtual: evProfesional?.virutal,
    extra: evProfesional?.extra,
    idTramo: evProfesional?.idTramo,
    viatico: evProfesional?.viatico,
    fechaAlta: evProfesional?.fechaAlta,
    idUsuario: evProfesional?.idUsuario,
    cambioSonda: evProfesional?.cambioSonda,
    capacitacion: evProfesional?.capacitacion,
    emergencia: evProfesional?.emergencia,
    extraduracion: evProfesional?.extraduracion,
    figuraProfesional: evProfesional?.figuraProfesional,
    profesional: evProfesional?.apellido + ", " + evProfesional?.nombre,
    idFrecuenciaPlan: evProfesional?.idFrecuenciaPlan,
    frecuenciaPlan: evProfesional?.frecuenciaPlan,
    idFrecuenciaRequerida: evProfesional?.idFrecuenciaRequerida,
    frecuenciaRequerida: evProfesional?.frecuenciaRequerida,
    puedeEditar: evProfesional?.puedeEditar,
    idEvaluacionProfesionalOriginal: evProfesional?.idEvaluacionProfesionalOriginal,
    profesionalOriginal: evProfesional?.apellidoOriginal + ", " + evProfesional?.nombreOriginal,
    fechaDesdeOriginal: evProfesional?.fechaDesdeOriginal,
    fechaHastaOriginal: evProfesional?.fechaHastaOriginal,
    idFrecuenciaRequeridaOriginal: evProfesional?.idFrecuenciaRequeridaOriginal,
    frecuenciaRequeridaOriginal: evProfesional?.frecuenciaRequeridaOriginal
  };
};

const adaptEvaluacionProfesionalReemplazoGrillaArray = (evaluacionProfesionalReemplazoGrilla) => {
  return structuredClone(evaluacionProfesionalReemplazoGrilla?.evaluacionProfesionalReemplazoGrilla.valorEsperado)?.
  map((evaluacionProfesional) => adaptEvaluacionProfesionalReemplazoGrilla(evaluacionProfesional)) || [];
};

export default adaptEvaluacionProfesionalReemplazoGrillaArray;